/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { type FunctionComponent } from 'react'

import { EuiText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { getPrettyValueWithDecimals } from '@modules/billing-lib/utils/formatter'

import DetailsSection from '../../../components/DetailsSection'

type Props = {
  amount: number
}

const TargetAmount: FunctionComponent<Props> = ({ amount }) => (
  <DetailsSection
    title={
      <FormattedMessage
        id='billing.notifications.budgets.budget-details.target-amount.title'
        defaultMessage='Target amount (ECU)'
      />
    }
    helpText={
      <FormattedMessage
        id='billing.notifications.budgets.budget-details.target-amount.help'
        defaultMessage='Used to track your actual spend against your planned spend. Costs are recorded within 24 hours.'
      />
    }
  >
    <EuiText size='s'>{getPrettyValueWithDecimals(amount, 0)}</EuiText>
  </DetailsSection>
)

export default TargetAmount
